import { Link } from 'react-router-dom';

export default function EstimateCTA() {
  return (
    <section className="relative h-[600px] overflow-hidden">
      <div className="absolute inset-0 grid grid-cols-1 lg:grid-cols-2">
        {/* Left - Image */}
        <div className="relative h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/6a71c32957d571f187a260b9a3f3be7b.jpg"
            alt="Beautiful patio at dusk"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        {/* Right - CTA Content */}
        <div className="relative h-full bg-[#E67E22] flex items-center justify-center p-12">
          <div className="max-w-lg text-center">
            <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl text-white/90 mb-10 leading-relaxed">
              Get a detailed estimate tailored to your vision and budget
            </p>
            <div className="space-y-4 mb-8">
              <Link to="/estimate" className="block w-full bg-white text-black px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-100 transition-all shadow-xl whitespace-nowrap cursor-pointer">
                Request Free Estimate
              </Link>
              <a href="tel:6105550123" className="block w-full bg-transparent border-2 border-white text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-white hover:text-[#E67E22] transition-all whitespace-nowrap cursor-pointer">
                Call (610) 555-0123
              </a>
            </div>
            <div className="flex items-center justify-center gap-6 text-sm text-white/80">
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line"></i>
                <span className="whitespace-nowrap">No obligation</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-chat-smile-3-line"></i>
                <span className="whitespace-nowrap">Free consultation</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span className="whitespace-nowrap">Quick response</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}